import { loadSurfaceChunk } from '@/i18n/loadSurface';
import { resolveRouteBundle } from '@/i18n/registry';
import type { HubUiLocale } from '@/i18n/types';
import type { LanguageCode } from '@/utils/languages/supportedLanguages';

export async function loadBundle(
  locale: LanguageCode,
  pathname: string
): Promise<Record<string, string>> {
  if (locale === 'en') {
    return {};
  }

  const { chunkIds } = resolveRouteBundle(pathname);
  const hubLocale: HubUiLocale = locale;
  const chunkBundles = await Promise.all(
    chunkIds.map((chunkId) => loadSurfaceChunk(chunkId, hubLocale))
  );

  return Object.assign({}, ...chunkBundles);
}
